module.exports = __webpack_public_path__ + "static/img/kexue1.1f5d4a8a.webp";